import { DISMISS, ADD } from './actions.js';

// import * as ActionTypes from '../actionTypes'
let methods = {};
const middleware = () => next => (action) => {
    if (!methods.dismissToast || !methods.showToast) {
        return next(action);
    }
    const { dismissToast, showToast } = methods;
    switch (action.type) {
        case ADD:
            showToast(action.payload.message, action.payload.variant, action.payload.autoDismiss);
            break;
        case DISMISS:
            dismissToast(action.payload.id);
            break;
    }
    return next(action);
};
const linkContextMethods = (externalMethods) => {
    const { showToast, dismissToast } = externalMethods;
    methods = { showToast, dismissToast };
};

export { linkContextMethods, middleware };
